export const GET_PURCHASE_ORDERS = 'GET_PURCHASE_ORDERS'
export const GET_PURCHASE_ORDER = 'GET_PURCHASE_ORDER'
export const ADD_PURCHASE_ORDER = 'ADD_PURCHASE_ORDER'
export const UPDATE_PURCHASE_ORDER = 'UPDATE_PURCHASE_ORDER'
export const DELETE_PURCHASE_ORDER_BY_ID = 'DELETE_PURCHASE_ORDER_BY_ID'
export const DELETE_PURCHASE_ORDERS_IN_BULK = 'DELETE_PURCHASE_ORDERS_IN_BULK'
export const GET_PDF_PURCHASE_ORDER_REPORT = 'GET_PDF_PURCHASE_ORDER_REPORT'
